
import { supabase } from "@/integrations/supabase/client";

export class UserActivityService {
  private static activityUpdateInterval: NodeJS.Timeout | null = null;
  private static lastUpdateTime: number = 0;

  static async updateUserActivity(userId: string): Promise<void> {
    try {
      console.log('🔄 Updating user activity for:', userId);
      
      // Call the database function to update last_seen
      const { error } = await supabase.rpc('update_user_last_seen', {
        user_id_param: userId
      });

      if (error) {
        console.error('❌ Error updating user activity:', error);
        throw error;
      }

      console.log('✅ User activity updated successfully');
    } catch (error) {
      console.error('❌ Failed to update user activity:', error);
      throw error;
    }
  }

  static startActivityTracking(userId: string): void {
    // Clear any existing interval
    this.stopActivityTracking();

    // Update activity immediately
    this.updateUserActivity(userId);

    // Set up periodic updates every 5 minutes
    this.activityUpdateInterval = setInterval(() => {
      this.updateUserActivity(userId).catch(console.error);
    }, 5 * 60 * 1000); // 5 minutes

    console.log('🎯 Started activity tracking for user:', userId);
  }

  static stopActivityTracking(): void {
    if (this.activityUpdateInterval) {
      clearInterval(this.activityUpdateInterval);
      this.activityUpdateInterval = null;
      console.log('⏹️ Stopped activity tracking');
    }
  }

  static async updateActivityOnAction(userId: string): Promise<void> {
    const now = Date.now();
    
    // Only update if more than 1 minute has passed since last update
    if (now - this.lastUpdateTime > 60 * 1000) {
      await this.updateUserActivity(userId);
      this.lastUpdateTime = now;
    }
  }
}
